import { Routes } from '@angular/router';
import { ClaimTypeComponent } from './features/refund/steps/claim-type/claim-type.component';
import { ThankyouPageComponent } from './features/refund/thankyou-page/thankyou-page.component';
import { Step1ExpensesComponent } from './features/refund/steps/step1-expenses/step1-expenses.component';
import { Step2SupportComponent } from './features/refund/steps/step2-support/step2-support.component';
import { Step3BankDataComponent } from './features/refund/steps/step3-bank-data/step3-bank-data.component';
import { Shell } from './shell/shell.service';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./features/auth/auth-routing.module').then(
        (m) => m.AuthRoutingModule
      ),
  },
  Shell.childRoutes([
    {
      path: 'refunds-medicals',
      component: ClaimTypeComponent,
    },
    {
      path: 'thankyou-page',
      component: ThankyouPageComponent,
    },
    {
      path: 'step1-expenses',
      component: Step1ExpensesComponent,
    },
    {
      path: 'step2-support',
      component: Step2SupportComponent,
    },
    {
      path: 'step3-bank-data',
      component: Step3BankDataComponent,
    },
    {
      path: 'refund',
      loadChildren: () =>
        import('./features/refund/refund.routes').then((m) => m.REFUND_ROUTES),
    },
  ]),
];
